type NativeAsset = {
  id: string
  symbol?: string
}

// USDC eligibility uses the native asset, but the withdrawal amount is drawn from the USD ledger asset.
export function resolveUsdcWithdrawalLedgerAsset(
  assets: Array<NativeAsset>,
): NativeAsset | undefined {
  return assets.find((asset) => asset.symbol?.trim().toUpperCase() === 'USD')
}

export function isUsdcNativeAsset(
  nativeAssetId: string | undefined,
  assets: Array<NativeAsset>,
): boolean {
  if (!nativeAssetId) return false

  const nativeAsset = assets.find((asset) => asset.id === nativeAssetId)
  return nativeAsset?.symbol?.trim().toUpperCase() === 'USDC'
}
